import { EditFormMode } from "../enums";
import { RydeUiUnit, TCrudEditAtomKey } from "../models";

/**
 * Module flag: the next unmount of this edit-form Recoil key should keep
 * `editFormDataAF` (duplicate / copy / reverse / save→edit). Default unmount
 * invalidates the cache so reopen fetches. Must not clear dto while the card
 * is still mounted with `id` — `useCrudEdit` would refetch on close.
 */
const keepEditFormDtoOnUnmountKeys = new Set<string>();

export const serializeCrudEditAtomKey = ([
  entity,
  mode,
]: TCrudEditAtomKey): string => `${entity}:${mode}`;

export const getEditFormCacheAtomKey = ({
  entity,
  mode,
}: {
  entity: RydeUiUnit;
  mode?: EditFormMode;
}): TCrudEditAtomKey => [entity, mode ?? EditFormMode.CrudRoute];

export const markKeepEditFormDtoOnUnmount = (key: TCrudEditAtomKey): void => {
  keepEditFormDtoOnUnmountKeys.add(serializeCrudEditAtomKey(key));
};

export const consumeKeepEditFormDtoOnUnmount = (
  key: TCrudEditAtomKey,
): boolean => {
  const serialized = serializeCrudEditAtomKey(key);
  const shouldKeep = keepEditFormDtoOnUnmountKeys.has(serialized);
  keepEditFormDtoOnUnmountKeys.delete(serialized);
  return shouldKeep;
};

export const resetKeepEditFormDtoOnUnmount = (): void => {
  keepEditFormDtoOnUnmountKeys.clear();
};
